import React from 'react';
import { LIQUID_TYPES, LIQUID_TYPE_LABELS } from '../types/aircraft';

interface LiquidTypeSelectorProps {
  selectedLiquidType: string;
  onLiquidTypeChange: (liquidType: string) => void;
}

const LiquidTypeSelector: React.FC<LiquidTypeSelectorProps> = ({
  selectedLiquidType,
  onLiquidTypeChange
}) => {
  return (
    <div className="form-group">
      <label htmlFor="liquidType">Тип жидкости</label>
      <select
        id="liquidType"
        name="liquidType"
        value={selectedLiquidType}
        onChange={(e) => onLiquidTypeChange(e.target.value)}
      >
        <option value="">Выберите тип жидкости</option>
        {Object.entries(LIQUID_TYPE_LABELS).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LiquidTypeSelector; 